import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { HelmetProvider } from "react-helmet-async";
import Navigation from "./Components/Components/Navigation";
import HomePage from "./Components/Pages/HomePage";
import Footer from "./Components/Components/Footer";
import ScrollToTop from "./Components/Components/ScrollToTop";
import { Routes, Route } from "react-router-dom";
import AboutPage from "./Components/Pages/AboutPage";
import ContactPage from "./Components/Pages/ContactPage";
import IndustriesPage from "./Components/Pages/IndustriesPage";
import ServicesPage from "./Components/Pages/ServicesPage";
import { Analytics } from "@vercel/analytics/react";

function App() {
  return (
    <HelmetProvider>
      <Analytics />
      <ScrollToTop />
      <Navigation />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/industries" element={<IndustriesPage />} />
      </Routes>
      <Footer />
    </HelmetProvider>
  );
}

export default App;
